import { BarChart2, FileText, LucideIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { usePermission } from "../../auth";
import PermissionGate from "../../apps/components/UI/PermissionGate";

interface ReportCardItem {
    name: string;
    description: string;
    icon: LucideIcon;
    reports: {
        name: string;
        redirectLink?: string;
        /** Right (view) required to open the report. */
        right?: string;
    }[];
}

const reportCards: ReportCardItem[] = [
    {
        name: "Panoptic Evaluation Reports",
        description: "Panoptic Evaluation Reports can be found here",
        icon: FileText,
        reports: [
            {
                name: "Panoptic Evaluation Score Card",
                redirectLink: "/panoptic-evaluation-score-card",
                right: "panoptic_evaluation_dashboard",
            },
        ],
    },
    {
        name: "Project Stages Reports",
        description: "Project Stages Reports can be found here",
        icon: BarChart2,
        reports: [],
    },
];

const SGReports = () => {
    const { can } = usePermission();
    return (
        <div className="accordion" id="reportsAccordion">
            {reportCards.map((item, index) => {
                const Icon = item.icon;
                return (
                    <div className="p-2 accordion-item border-0 mb-4 shadow-apple-sm rounded-4" key={index}>
                        {/* Header */}
                        <h2 className="accordion-header" id={`heading-${index}`}>
                            <button
                                className="accordion-button collapsed d-flex align-items-center p-3"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`#collapse-${index}`}
                                aria-expanded="false"
                                aria-controls={`collapse-${index}`}
                            >
                                <div className="d-flex align-items-center">
                                    <div
                                        className="p-3 rounded-4 me-3"
                                        style={{ background: "#e5e8fb" }}
                                    >
                                        <Icon size={24} style={{ color: "#4f7eee" }} />
                                    </div>

                                    <div>
                                        <h5 className="mb-1">{item.name}</h5>
                                        <small className="text-muted">{item.description}</small>
                                    </div>
                                </div>
                            </button>
                        </h2>

                        {/* Body */}
                        <div
                            id={`collapse-${index}`}
                            className="accordion-collapse collapse"
                            aria-labelledby={`heading-${index}`}
                            data-bs-parent="#reportsAccordion"
                        >
                            <div className="accordion-body px-0 pt-2">
                                {item.reports.length > 0 ? (
                                    <ul className="list-unstyled mb-0 row">
                                        {item.reports.map((report, i) => (
                                            <li key={i} className="col-12 col-sm-6">
                                                <PermissionGate allowed={!report.right || can(report.right, 'view')} className="d-block">
                                                    <Link
                                                        to={report.redirectLink || "#"}
                                                        className="d-flex align-items-center justify-content-between px-3 py-3 mb-2 rounded-3 text-decoration-none report-item"
                                                    >
                                                        <span className="fw-semibold text-dark fs-6">
                                                            {report.name}
                                                        </span>
    
                                                        <span className="text-muted">
                                                            →
                                                        </span>
                                                    </Link>
                                                </PermissionGate>
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <div className="text-center py-3 text-muted">
                                        Coming soon...
                                    </div>
                                )}
                            </div>
                        </div>
                        <style >
                            {
                                `.report-item {
  background: #f8f9fc;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}

.report-item:hover {
  background: #eef2ff;
  border-color: #dbe3ff;
  transform: translateX(4px);
}

.report-item span:last-child {
  font-size: 14px;
}`
                            }
                        </style>
                    </div>
                );
            })}
        </div>
    );
};

export default SGReports;